const FIELD_PROP_NAMES = [
  "children",
  "className",
  "error",
  "hidden",
  "id",
  "label",
  "name",
  "onChange",
  "onlyDirtyErrors",
  "toolTip",
];

interface FieldPropsType {
  children: JSX.Element;
  className?: string;
  error?: string;
  hidden?: boolean;
  id?: string;
  label: string | JSX.Element;
  name: string;
  onBlur?(): void;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onChange?(e: any): void;
  onlyDirtyErrors?: boolean;
  toolTip?: JSX.Element;
}

interface SelectInputPropsType {
  id?: string;
  name: string;
  onBlur?(): void;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onChange?(e: any): void;
  options: SelectOptionType[];
  placeholder?: string;
  value?: string;
}

interface SelectOptionType {
  isPlaceholder?: boolean;
  label: string;
  value: string;
}

export {
  FIELD_PROP_NAMES,
  FieldPropsType,
  SelectInputPropsType,
  SelectOptionType,
};
